import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import AppContext from "../context/AppContext";
import PackageEmpty from "../assets/svg/v2/plans/none.svg";
import Package25 from "../assets/svg/v2/plans/1.svg";
import Package100 from "../assets/svg/v2/plans/2.svg";
import Package250 from "../assets/svg/v2/plans/3.svg";
import Package500 from "../assets/svg/v2/plans/4.svg";
import Package1000 from "../assets/svg/v2/plans/5.svg";
import Package2500 from "../assets/svg/v2/plans/6.svg";
import Package5000 from "../assets/svg/v2/plans/7.svg";
import Package10000 from "../assets/svg/v2/plans/8.svg";
import GlobalVolumen from "../components/GlobalVolumen";
import Countdown from "../components/Countdown"
import UnilevelCard from "../assets/svg/cards/unilevel-card.svg"
import TotalCard from "../assets/svg/cards/total-card.svg"
import RangeCard from "../assets/svg/cards/range-card.svg"
import MatchingCard from "../assets/svg/cards/matching-card.svg"
import CopyCard from "../assets/svg/cards/copy-card.svg"
import BinaryCard from "../assets/svg/cards/binary-card.svg"
import BarCard from "../assets/svg/cards/bar-card.svg"
import StatusNetwork from "../components/StatusNetwork";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import BinaryTreeLoading from "../components/BinaryTreeLoading";

import LanguageAndNotificacions from "../components/LanguageAndNotificacions";

export default function Network() {
  const { t } = useTranslation();
  const { loading, updateLoading, showTanks, saveTanks, sharetanks, showDirects } = useContext(AppContext);
  const [searchEmail, setSearchEmail] = useState("");
  const [networks, setNetworks] = useState([]);
  const [dateFilter, setDateFilter] = useState();
  const [showDatePicker, setShowDatePicker] = useState(false); // Controla la visibilidad del selector de fecha
  const [directs, setDirects] = useState([]);
  const [tanks, setTanks] = useState([]); // Guardar los datos filtrados con `sponsor_child_id = null`
  const [emailSearch, setEmailSearch] = useState(""); // Estado para almacenar el email ingresado
  const [filteredTanks, setFilteredTanks] = useState([]); // Estado para almacenar los resultados filtrados por email
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(150);
  const [total, setTotal] = useState(0);
  const [emailButton, setEmailButton] = useState(false);
  const [userData, setUserData] = useState([]);
  const [prevUser, setPrevUser] = useState(window.localStorage.getItem("id"));
  const [actualUser, setActual] = useState(window.localStorage.getItem("id"));
  const [percentage, setPercentage] = useState(0);
  const [earningsTotal, setEarningsTotal] = useState(0);
  const [rangeData, setRangeData] = useState([]);
  const [sponsorChild, setSponsorChild] = useState([]);
  const [sponsorBlock, setsponsorBlock] = useState(0);
  const [leftChild, setLeftChild] = useState([]);
  const [rightChild, setRightChild] = useState([]);
  const [rightGrandChildren, setRightGrandChildren] = useState([]);
  const [leftGrandChildren, setLeftGrandChildren] = useState([]);
  const [updateBinary, setUpdateBinary] = useState(false);
  const [settings, setSettings] = useState([]);
  const [balance, setBalance] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");


  useEffect(() => {
    getNetworks();
    getDirects();
    myUser();
    getNodes();
  }, []);

  useEffect(() => {
    const settingsVar = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: total >= 6 ? 6 : total,
      slidesToScroll: 1,
      initialSlide: 0,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: total >= 6 ? 6 : total,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };
    setSettings(settingsVar)
  }, [total]);

  const getNetworks = (date) => {
    updateLoading(true);
    fetch(`${process.env.REACT_APP_BACKEND}/users-networks?date=${date}`, {
      method: "GET",
      headers: {
        Authorization: `${localStorage.getItem("token")}`,
      },
    })
      .then((response) => response.json())
      .then((response) => {

        // Valores por defecto de los niveles
        const levelsDefault = [
          { level: 1, percentage: '7%', status: 0 },
          { level: 2, percentage: '3%', status: 0 },
          { level: 3, percentage: '2%', status: 0 },
          { level: 4, percentage: '2%', status: 0 },
          { level: 5, percentage: '1%', status: 0 },
          { level: 6, percentage: '1%', status: 0 },
          { level: 7, percentage: '1%', status: 0 },
          { level: 8, percentage: '3%', status: 0 },
        ];

        // Datos del response
        const networkData = response?.data || [];

        // Combina los niveles predeterminados con los del response
        const combinedLevels = levelsDefault.map((defaultLevel) => {
          const matchedLevel = networkData.find((item) => parseInt(item.level) === parseInt(defaultLevel.level));
          return matchedLevel ? { ...defaultLevel, ...matchedLevel } : defaultLevel;
        });

        // Actualiza el estado con los niveles combinados
        setNetworks(combinedLevels);
        setDateFilter(response?.date);
        updateLoading(false);
      })
      .catch((error) => {
        console.log(error);
        updateLoading(false);
      });
  };



  const myUser = () => {
    fetch(`${process.env.REACT_APP_BACKEND}/users`, {
      method: "GET",
      headers: {
        Authorization: `${localStorage.getItem("token")}`,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        const data = response?.data;
        setUserData(data);
        setRangeData(response?.range)
        if (data && data.package_value_maximun && data.package_value_current) {
          const max = data.package_value_maximun;
          const current = data.package_value_current;
          const calculatedPercentage = (current / max) * 100;
          setPercentage(calculatedPercentage);
        }
        setBalance(parseFloat(data?.balance_available) + parseFloat(data?.balance_referral) + parseFloat(data?.balance_binary) + parseFloat(data?.balance_matching) + parseFloat(data?.balance_bonus) + parseFloat(data?.balance_residual));
        setEarningsTotal(parseFloat(data?.total_available) + parseFloat(data?.total_referral) + parseFloat(data?.total_binary) + parseFloat(data?.total_matching) + parseFloat(data?.total_bonus) + parseFloat(data?.total_residual));

      })
      .catch((error) => {
        console.log(error);
        updateLoading(false);
      });
  };



  const getNodes = () => {
    updateLoading(true);
    fetch(`${process.env.REACT_APP_BACKEND}/nodes`, {
      method: "GET",
      headers: {
        Authorization: `${localStorage.getItem("token")}`,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        updateLoading(false);
        setSponsorChild(response?.data?.users_id || null);
        setsponsorBlock(response?.data?.sponsor_my || null)
        setLeftChild(response?.data?.left || null);
        setRightChild(response?.data?.right || null);
        setRightGrandChildren(response?.data?.right || []);
        setLeftGrandChildren(response?.data?.left || []);
      })
      .catch((error) => {
        console.log(error);
        updateLoading(false);
      });
  };




  const getUsersNode = (id) => {
    if (!id) {
      return;
    }
    if (sponsorBlock === id) {
      toast.error(t("_NETWORK._ERROR"));
      return;
    }
    console.log(id)
    setUpdateBinary(true);
    fetch(`${process.env.REACT_APP_BACKEND}/nodes?user=${id}`, {
      method: "GET",
      headers: {
        Authorization: `${localStorage.getItem("token")}`,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status === false) {
          toast.error(t("_NETWORK._ERROR"));
        } else {
          toast.success(t("_NETWORK._SUCCESS"));
          setSponsorChild(response?.data?.users_id || null);
          setLeftChild(response?.data?.left || null);
          setRightChild(response?.data?.right || null);
          setRightGrandChildren(response?.data?.right || []);
          setLeftGrandChildren(response?.data?.left || []);
        }
        setUpdateBinary(false);
      })
      .catch((error) => {
        console.log(error);
        setUpdateBinary(false);
      });
  };


  const getUsersDataEmail = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(searchEmail)) {
      toast.error(t("_NETWORK._ERROR"));
      return;
    }
    updateLoading(true);
    const formData = new FormData();
    formData.append("identify", searchEmail);
    fetch(`${process.env.REACT_APP_BACKEND}/users-directs-emails`, {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `${localStorage.getItem("token")}`,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status === false) {
          toast.error(t("_NETWORK._ERROR"));
        } else {
          toast.success(t("_NETWORK._SUCCESS"));
          setDirects([response?.data])

          setTotal(response?.total)
          setPrevUser(response?.parnert);
        }
        updateLoading(false);
      })
      .catch((error) => {
        console.log(error);
        updateLoading(false);
      });
  };


  const getDirects = () => {
    updateLoading(true);
    fetch(`${process.env.REACT_APP_BACKEND}/directs?page=${page}&limit=${limit}`, {
      method: "GET",
      headers: {
        Authorization: `${localStorage.getItem("token")}`,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        setDirects(response?.data)
        setTotal(response?.total)
        const filteredData = response?.data.filter((item) => item.sponsor_child_id === null);
        setTanks(filteredData);
        updateLoading(false);
      })
      .catch((error) => {
        console.log(error);
        updateLoading(false);
      });
  };

  // Función para buscar por email en los datos de `setTanks()`
  const filterByEmail = () => {
    const filtered = tanks.filter((item) => item.name.toLowerCase().includes(emailSearch.toLowerCase()));
    setFilteredTanks(filtered);
  };

  // Input y llamada a la función de filtro
  const handleEmailSearch = (e) => {
    setEmailSearch(e.target.value); // Actualiza el valor del email en el estado
  };

  useEffect(() => {
    console.log(emailSearch);
    if (emailSearch !== "") {
      filterByEmail(); // Filtra cuando el email no está vacío
    } else {
      setFilteredTanks(tanks); // Si no hay búsqueda, muestra todos los datos filtrados por sponsor_child_id = null
    }
  }, [emailSearch, tanks]); // Se vuelve a ejecutar cuando `emailSearch` o `tanks` cambian


  useEffect(() => {
    getNodes();
    getDirects();
  }, [sharetanks]);


  const changeDate = (days) => {
    getNetworks(days);
    setShowDatePicker(false);
  };

  const changeDateByDays = (date, days) => {
    const result = new Date(date);
    result.setUTCDate(result.getUTCDate() + days);
    const year = result.getUTCFullYear();
    const month = String(result.getUTCMonth() + 1).padStart(2, '0');
    const day = String(result.getUTCDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  const switchPackage = (position) => {
    switch (position) {
      case "0":
        return PackageEmpty
      case "1":
        return Package25
      case "2":
        return Package100
      case "3":
        return Package250
      case "4":
        return Package500
      case "5":
        return Package1000
      case "6":
        return Package2500
      case "7":
        return Package5000
      case "8":
        return Package10000
      default:
        return PackageEmpty; // En caso de que la posición esté fuera del rango esperado
    }
  };


  const formatNumber = (value) => {
    if (value >= 1000000) {
      return (value / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    }
    if (value >= 1000) {
      return (value / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
    }
    const valueString = value.toString();
    const [integerPart, decimalPart] = valueString.split('.');

    if (decimalPart && decimalPart.length > 3) {
      return `${integerPart}.${decimalPart.slice(0, 3)}`;
    }

    return valueString;
  };


  const oraculo = (props) => {
    if (window.localStorage.getItem("tron")) {
      let value = props / window.localStorage.getItem("tron");
      let fomart = Number.parseFloat(value).toFixed(3);
      let valueFormat = formatNumber(fomart);
      return valueFormat;
    }
  };

  const showTank = (item) => {
    saveTanks(item);
    showTanks(true);
  }


  const showDirect = (item) => {
    saveTanks(item);
    showDirects(true);
  }


  const getTranslatedDirection = (dir) => {
    if (!dir) return "N/A";
    return dir === 'left' ? t("_NETWORK._LEFT") : t("_NETWORK._RIGHT");
  };

  const filteredDirects = directs.filter((item) =>
    item?.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <div className="flex flex-col lg:flex-row lg:justify-between w-3/4 lg:w-full gap-3">
        <h1 className="text-white text-3xl">{t("_SIDEBAR._NETWORK")}</h1>
        <LanguageAndNotificacions />
      </div>
      {/*** Search Users */}
      <div className="max-w-7xl mx-auto p-4 lg:p-6">
        <div className="bg-black/60 text-white lg:p-8 p-4 rounded-lg w-full border-zinc-600 border-2 flex flex-col lg:flex-row gap-4">
          <div className="flex flex-col lg:w-2/5 w-full gap-4">
            <div className="flex flex-row gap-4">
              <div className="relative">
                <input type="email" className="block w-full p-4 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500" placeholder={t("_LOGIN._EMAIL")} required onChange={e => setSearchEmail(e.target.value)} />
                <button type="button" className="text-white absolute end-2.5 bottom-2.5  focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 " onClick={() => getUsersDataEmail()}>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-4">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                  </svg>
                </button>
              </div>
              <div className="relative">
                <input type="text" value={userData?.created} className="block w-full p-4 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 disabled cursor-not-allowed" />
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="text-white absolute end-2.5 bottom-4 w-6">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
                </svg>
              </div>
            </div>
            <div className="bg-black/60 text-white rounded-lg w-full border-zinc-600 border-2 gap-4">
              <div className="lg:px-8  p-4 ">
                <h3 className="text-center my-2">{userData?.name ? (userData?.name.length > 10 ? userData.name.substr(0, 10) + '...' : userData?.name) : userData?.name} </h3>
                <div className="text-center relative">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-60 mx-auto shim-green rounded-3xl">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                  </svg>
                </div>
              </div>
              <hr className="border-t-2 h-2 border-zinc-600"></hr>
              <div className="flex flex-col lg:flex-row gap-2 my-4">
                <div className="flex flex-row w-full lg:w-1/2 justify-left lg:justify-center items-center gap-2">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-10 w-1/2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
                  </svg>
                  <div className="flex flex-col gap-2 w-1/2">
                    <p className="text-sm">{t("_REGISTER._EMAIL")}</p>
                    <p className="text-xs">{userData?.email ? (userData?.email.length > 10 ? userData.email.substr(0, 10) + '...' : userData?.email) : userData?.email}</p>
                  </div>
                </div>
                <div className="flex flex-row w-full lg:w-1/2 justify-left lg:justify-center items-center gap-2">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-10 w-1/2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 1.5H8.25A2.25 2.25 0 0 0 6 3.75v16.5a2.25 2.25 0 0 0 2.25 2.25h7.5A2.25 2.25 0 0 0 18 20.25V3.75a2.25 2.25 0 0 0-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3" />
                  </svg>
                  <div className="flex flex-col gap-2 w-1/2">
                    <p className="text-sm">{t("_REGISTER._WHATSAPP")}</p>
                    <p className="text-xs">{userData?.whatsapps}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col lg:w-3/5 w-full">
            <div className="w-full h-24 border-zinc-700 hover:border-zinc-400 border-2 rounded-xl bg-cover text-white relative" style={{ backgroundImage: `url(${BarCard})` }}>
              <div className="flex justify-between my-2 m-5">
                <p className="text-sm">{t("_DASHBOARD._FINISH")}: {userData?.package_value_maximun || 0} USD</p>
              </div>
              <div className="relative h-4 rounded-2xl overflow-hidden bg-gray-300 my-2 mx-5">
                <div className="absolute top-0 h-4 rounded-2xl shim-green"
                  style={{ width: `${percentage}%` }}>
                </div>
              </div>
              <div className="mx-5 flex flex-row justify-between my-2">
                <div className="flex flex-row justify-center items-center">
                  <p className="hidden lg:block text-sm"> {t("_DASHBOARD._STATUS")}: {userData?.active === "1" ? t("_DASHBOARD._STATUS_ACTIVE") : t("_DASHBOARD._STATUS_INACTIVE")}</p>
                </div>
                <p className="text-sm"> {t("_DASHBOARD._CURRENT")}: {userData?.package_value_current ? userData?.package_value_current : "0"} USD - {percentage ? percentage.toFixed(2) : "0"}%</p>
              </div>
            </div>
            <div className="my-8 flex flex-col lg:flex-row gap-2">
              <div className="lg:w-4/5 w-full flex flex-col gap-2">
                <div className="flex flex-col lg:flex-row gap-2">
                  <div className="w-full lg:w-1/2 h-44 p-4 flex flex-col justify-between border-zinc-700 hover:border-zinc-400 border-2 rounded-xl bg-cover text-white" style={{ backgroundImage: `url(${UnilevelCard})` }} >
                    <h1 className="text-sm">{t("_DASHBOARD._TITLE7")} </h1>
                    <div className="group gap-2 flex flex-col ">
                      <div className="flex group-hover:hidden transition-opacity duration-300 opacity-100 group-hover:opacity-0  flex-row gap-2 text-white w-full flex-end">
                        <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{formatNumber(userData?.balance_referral || 0)}</p>
                        <p className="w-2/5">USD</p>
                      </div>
                      <div className="flex group-hover:hidden transition-opacity duration-300 opacity-100 group-hover:opacity-0  flex-row  gap-2 text-white w-full  flex-end">
                        <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end"> {formatNumber(userData?.total_referral || 0)}</p>
                        <p className="w-2/5">{t("_DASHBOARD._TOTAL")}</p>
                      </div>
                      <div className="hidden group-hover:flex transition-opacity duration-300 opacity-0 group-hover:opacity-100  flex-row  gap-2 text-white w-full  flex-end">
                        <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{oraculo(userData?.balance_referral)}</p>
                        <p className="w-2/5">SOL</p>
                      </div>
                      <div className="hidden group-hover:flex transition-opacity duration-300 opacity-0 group-hover:opacity-100  flex-row  gap-2 text-white w-full  flex-end">
                        <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{oraculo(userData?.total_referral)}</p>
                        <p className="w-2/5">{t("_DASHBOARD._TOTAL")}</p>
                      </div>
                    </div>
                  </div>
                  <div className="w-full lg:w-1/2 h-44 p-4 flex flex-col justify-between border-zinc-700 hover:border-zinc-400 border-2 rounded-xl bg-cover text-white" style={{ backgroundImage: `url(${BinaryCard})` }}>
                    <h1 className="text-sm">{t("_DASHBOARD._TITLE8")}</h1>
                    <div className="group gap-2 flex flex-col ">
                      <div className="flex group-hover:hidden transition-opacity duration-300 opacity-100 group-hover:opacity-0  flex-row gap-2 text-white w-full flex-end">
                        <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{formatNumber(userData?.balance_binary || 0)}</p>
                        <p className="w-2/5">USD</p>
                      </div>
                      <div className="flex group-hover:hidden transition-opacity duration-300 opacity-100 group-hover:opacity-0  flex-row  gap-2 text-white w-full  flex-end">
                        <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end"> {formatNumber(userData?.total_binary || 0)}</p>
                        <p className="w-2/5">{t("_DASHBOARD._TOTAL")}</p>
                      </div>
                      <div className="hidden group-hover:flex transition-opacity duration-300 opacity-0 group-hover:opacity-100  flex-row  gap-2 text-white w-full  flex-end">
                        <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{oraculo(userData?.balance_binary)}</p>
                        <p className="w-2/5">SOL</p>
                      </div>
                      <div className="hidden group-hover:flex transition-opacity duration-300 opacity-0 group-hover:opacity-100  flex-row  gap-2 text-white w-full  flex-end">
                        <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{oraculo(userData?.total_binary)}</p>
                        <p className="w-2/5">{t("_DASHBOARD._TOTAL")}</p>
                      </div>
                    </div>
                  </div>
                  <div className="w-full lg:w-1/2 h-44 p-4 flex flex-col justify-between border-zinc-700 hover:border-zinc-400 border-2 rounded-xl bg-cover text-white" style={{ backgroundImage: `url(${CopyCard})` }}>
                    <h1 className="text-sm">{t("_DASHBOARD._TITLE10")}</h1>
                    <div className="group gap-2 flex flex-col ">
                      <div className="flex group-hover:hidden transition-opacity duration-300 opacity-100 group-hover:opacity-0  flex-row gap-2 text-white w-full flex-end">
                        <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{formatNumber(userData?.balance_residual || 0)}</p>
                        <p className="w-2/5">USD</p>
                      </div>
                      <div className="flex group-hover:hidden transition-opacity duration-300 opacity-100 group-hover:opacity-0  flex-row  gap-2 text-white w-full  flex-end">
                        <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end"> {formatNumber(userData?.total_residual || 0)}</p>
                        <p className="w-2/5">{t("_DASHBOARD._TOTAL")}</p>
                      </div>
                      <div className="hidden group-hover:flex transition-opacity duration-300 opacity-0 group-hover:opacity-100  flex-row  gap-2 text-white w-full  flex-end">
                        <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{oraculo(userData?.balance_residual)}</p>
                        <p className="w-2/5">SOL</p>
                      </div>
                      <div className="hidden group-hover:flex transition-opacity duration-300 opacity-0 group-hover:opacity-100  flex-row  gap-2 text-white w-full  flex-end">
                        <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{oraculo(userData?.total_residual)} </p>
                        <p className="w-2/5">{t("_DASHBOARD._TOTAL")}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col lg:flex-row gap-2">
                  <div className="w-full lg:w-1/2 h-44 p-4 flex flex-col justify-between border-zinc-700 hover:border-zinc-400 border-2 rounded-xl bg-cover text-white" style={{ backgroundImage: `url(${RangeCard})` }}>
                    <h1 className="text-sm">{t("_DASHBOARD._TITLE5")}</h1>
                    <div className="group gap-2 flex flex-col ">
                      <div className="flex group-hover:hidden transition-opacity duration-300 opacity-100 group-hover:opacity-0  flex-row gap-2 text-white w-full flex-end">
                        <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{formatNumber(userData?.balance_bonus || 0)}</p>
                        <p className="w-2/5">USD</p>
                      </div>
                      <div className="flex group-hover:hidden transition-opacity duration-300 opacity-100 group-hover:opacity-0  flex-row  gap-2 text-white w-full  flex-end">
                        <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end"> {formatNumber(userData?.total_bonus || 0)}</p>
                        <p className="w-2/5">{t("_DASHBOARD._TOTAL")}</p>
                      </div>
                      <div className="hidden group-hover:flex transition-opacity duration-300 opacity-0 group-hover:opacity-100  flex-row  gap-2 text-white w-full  flex-end">
                        <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{oraculo(userData?.balance_bonus)}</p>
                        <p className="w-2/5">SOL</p>
                      </div>
                      <div className="hidden group-hover:flex transition-opacity duration-300 opacity-0 group-hover:opacity-100  flex-row  gap-2 text-white w-full  flex-end">
                        <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{oraculo(userData?.total_bonus)} </p>
                        <p className="w-2/5">{t("_DASHBOARD._TOTAL")}</p>
                      </div>
                    </div>
                  </div>
                  <div className="w-full lg:w-1/2 h-44 p-4 flex flex-col justify-between border-zinc-700 hover:border-zinc-400 border-2 rounded-xl bg-cover text-white" style={{ backgroundImage: `url(${MatchingCard})` }}>
                    <h1 className="text-sm">{t("_DASHBOARD._TITLE9")}</h1>
                    <div className="group gap-2 flex flex-col ">
                      <div className="flex group-hover:hidden transition-opacity duration-300 opacity-100 group-hover:opacity-0  flex-row gap-2 text-white w-full flex-end">
                        <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{formatNumber(userData?.balance_matching || 0)}</p>
                        <p className="w-2/5">USD</p>
                      </div>
                      <div className="flex group-hover:hidden transition-opacity duration-300 opacity-100 group-hover:opacity-0  flex-row  gap-2 text-white w-full  flex-end">
                        <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end"> {formatNumber(userData?.total_matching || 0)}</p>
                        <p className="w-2/5">{t("_DASHBOARD._TOTAL")}</p>
                      </div>
                      <div className="hidden group-hover:flex transition-opacity duration-300 opacity-0 group-hover:opacity-100  flex-row  gap-2 text-white w-full  flex-end">
                        <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{oraculo(userData?.balance_matching)}</p>
                        <p className="w-2/5">SOL</p>
                      </div>
                      <div className="hidden group-hover:flex transition-opacity duration-300 opacity-0 group-hover:opacity-100  flex-row  gap-2 text-white w-full  flex-end">
                        <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{oraculo(userData?.total_matching)}</p>
                        <p className="w-2/5">{t("_DASHBOARD._TOTAL")}</p>
                      </div>
                    </div>
                  </div>
                  <div className="w-full lg:w-1/2 h-44 p-4 flex flex-col justify-between border-zinc-700 hover:border-zinc-400 border-2 rounded-xl bg-cover text-white" style={{ backgroundImage: `url(${TotalCard})` }}>
                    <h1 className="text-sm">{t("_DASHBOARD._TITLE3")}</h1>
                    <div className="group gap-2 flex flex-col ">
                      <div className="flex transition-opacity duration-300 opacity-100 flex-row gap-2 text-white w-full flex-end">
                        <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{formatNumber(earningsTotal || 0)}</p>
                        <p className="w-2/5">USD</p>
                      </div>
                      <div className="flex transition-opacity duration-300 opacity-100 flex-row  gap-2 text-white w-full  flex-end">
                        <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end"> {formatNumber(earningsTotal || 0)}</p>
                        <p className="w-2/5">SOL</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="lg:w-1/5 w-full flex flex-col-reverse gap-2">
                <GlobalVolumen userData={userData} rangeData={rangeData} network={true} />
              </div>
            </div>
          </div>
        </div>
        {/** Directs for Users 
        <div className="bg-black/60 text-white lg:p-8 p-4 rounded-lg w-full border-zinc-600 border-2  gap-4 my-4 w-full">
          <h2 className="text-2xl my-2">{t("_NETWORK._DIRECTS")}</h2>
          <div className="w-4/5 mx-auto slider-container">
            <Slider {...settings}>
              {directs.map(item => (
                <div key={item.id} className="bg-gray-800 rounded-lg shadow-lg cursor-pointer opacity-50 hover:opacity-100 mr-6 border-zinc-600 border-2 lg:max-w-32 flex flex-col gap-6 text-center p-4" onClick={() => showDirect(item)}>
                  <h3 className="text-sm font-semibold text-white"> {item.name.length > 10 ? item.name.substr(0, 10) + '...' : item.name}</h3>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-10 mx-auto shim-green rounded-3xl my-4">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                  </svg>
                  <p>GV:</p>
                  <p>{formatNumber(item?.range_volumen || 0)}</p>
                </div>
              ))}
            </Slider>
          </div>
        </div>
        */}
        {/** Live Tank */}
        {filteredTanks.length > 0 && (
          <div className="bg-black/60 text-white lg:p-8 p-4 rounded-lg w-full border-zinc-600 border-2  gap-4 my-4 w-full ">
            <h2 className="text-2xl my-2">{t("_NETWORK._TANK")}</h2>
            <input
              type="text"
              placeholder={t("_NETWORK._SEARCHFORUSERNAME")}
              value={emailSearch}
              onChange={handleEmailSearch}
              className="my-2"
            />
            <div className="w-4/5 mx-auto slider-container">
              <Slider {...settings}>
                {filteredTanks.map(item => (
                  <div key={item.id} className="bg-gray-800 rounded-lg shadow-lg cursor-pointer opacity-50 hover:opacity-100 border-zinc-600 border-2 lg:max-w-32 flex flex-col gap-6 text-center p-4" onClick={() => showTank(item)}>
                    <h3 className="text-sm font-semibold text-white"> {item.name.length > 10 ? item.name.substr(0, 10) + '...' : item.name}</h3>
                    <img
                      className={`w-32 h-32 mx-auto z-40 `}
                      src={switchPackage(item?.package)}
                      alt={item?.package}
                    />
                    <p>GV:</p>
                    <p>{formatNumber(item?.range_volumen || 0)}</p>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        )}
        {/** Binary Tree */}
        <div className="bg-black/60 text-white lg:p-8 p-4 rounded-lg w-full border-zinc-600 border-2  gap-4 my-4 w-full">
          <div className="flex flex-col lg:flex-row gap-4 px-8">
            {t("_COUNTDOWN._TITLE")}
            <h4><Countdown targetDate={sponsorChild?.binaryDate} /></h4>
          </div>
          <div className="flex flex-col lg:flex-row gap-4 p-4">
            <div className="w-full lg:w-1/2 bg-gladiaverse rounded-lg shadow-md text-white p-4">

              <h4>{t("_NETWORK._LEFT")}</h4>
              <p>{t("_NETWORK._AVAILABLE")}: {sponsorChild?.balance_binary_left || 0} Points</p>
              <p>{t("_NETWORK._TOTALLEFT")}: {sponsorChild?.total_binary_left || 0} Points</p>
            </div>
            <div className="w-full lg:w-1/2 bg-gladiaverse rounded-lg shadow-md text-white p-4">
              <h4>{t("_NETWORK._RIGHT")}</h4>
              <p>{t("_NETWORK._AVAILABLE")}: {sponsorChild?.balance_binary_right || 0} Points</p>
              <p>{t("_NETWORK._TOTALRIGHT")}: {sponsorChild?.total_binary_right || 0} Points</p>
            </div>
          </div>
          <div className="flex flex-col lg:flex-row gap-4 p-4">
            <div className="flex flex-col items-center space-y-8 bg-gladiaverse lg:pt-10 lg:pb-20 py-10 w-full rounded-lg shadow-md">
              {updateBinary ?
                <>
                  <BinaryTreeLoading />
                </ >
                :
                <>
                  <div className="flex justify-center flex-col relative w-36 group my-10 lg:mt-10 lg:my-10 cursor-pointer">
                    <img
                      className={`w-32 h-32 mx-auto z-40 ${sponsorChild ? '-bottom-11 opacity-90 hover:opacity-100 ' : '-bottom-10 hidden'}`}
                      src={switchPackage(sponsorChild?.package)}
                      onClick={() => getUsersNode(sponsorChild?.sponsor_child_id)}
                      alt={sponsorChild?.name}
                    />
                    <p className="text-white absolute -top-8 text-lg left-1/2 transform -translate-x-1/2 truncate max-w-full">{sponsorChild?.name?.length > 30 ? sponsorChild.name.substring(0, 30) + '...' : sponsorChild?.name}</p>
                  </div>
                  <div className="flex flex-col w-full justify-center pb-20 my-20 ">
                    <div className="flex flex-col items-center justify-center lg:flex-row lg:justify-around lg:space-x-8 w-full space-y-24 lg:space-y-0">
                      <div className="flex justify-around flex-col relative w-36 group cursor-pointer items-center">
                        {/*  <StatusNetwork active={leftChild?.active || 0} /> */}
                        <img className={`w-32 h-32 mx-auto z-40 ${leftChild ? '-bottom-11 opacity-70 hover:opacity-100 ' : 'opacity-10 -bottom-10 cursor-not-allowed'}`}
                          src={switchPackage(leftChild?.package)}
                          onClick={() => getUsersNode(leftChild?.id || null)} alt={userData?.name} />
                        <p className="text-white group-hover:opacity-100 transition-opacity absolute -bottom-14 left-1/2 transform -translate-x-1/2 "> {leftChild?.name ? leftChild?.name : ""} <span className="block lg:hidden text-blue-200 uppercase"> {t("_NETWORK._LEFT")}</span></p>
                      </div>
                      <div className="flex justify-around flex-col relative w-36 group cursor-pointer  items-center">
                        {/*   <StatusNetwork active={rightChild?.active || 0} /> */}
                        <img className={`w-32 h-32 mx-auto z-40 ${rightChild ? '-bottom-11 opacity-70 hover:opacity-100 ' : 'opacity-10 -bottom-10 cursor-not-allowed'}`}
                          src={switchPackage(rightChild?.package)}
                          onClick={() => getUsersNode(rightChild?.id || null)} alt={userData?.name} />
                        <p className="text-white group-hover:opacity-100 transition-opacity absolute -bottom-14 left-1/2 transform -translate-x-1/2">{rightChild?.name ? rightChild?.name : ""} <span className="block lg:hidden text-blue-200 uppercase"> {t("_NETWORK._RIGHT")}</span></p>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-row w-full justify-center pb-20 my-20">
                    <div className="flex flex-col items-center  lg:flex-row lg:justify-around lg:space-x-8 w-full space-y-24 lg:space-y-0">
                      <div className="flex justify-around  flex-col relative w-36 group cursor-pointer">
                        <img className={`w-32 h-32  mx-auto z-40 ${leftGrandChildren?.left_child ? '-bottom-11 opacity-70 hover:opacity-100 ' : 'opacity-10 -bottom-10 cursor-not-allowed'}`} src={switchPackage(leftGrandChildren?.left_child?.package)} alt={userData?.name} onClick={() => getUsersNode(leftGrandChildren?.left_child?.id || null)} />
                        <p className="text-white group-hover:opacity-100 transition-opacity absolute -bottom-14 left-1/2 transform -translate-x-1/2"> {leftGrandChildren?.left_child?.name || ""} <span className="block lg:hidden text-blue-200 uppercase"> {t("_NETWORK._LEFT")}</span></p>
                      </div>
                      <div className="flex justify-around  flex-col relative w-36 group cursor-pointer" >
                        <img className={`w-32 h-32  mx-auto z-40 ${leftGrandChildren?.right_child ? '-bottom-11 opacity-70 hover:opacity-100 ' : 'opacity-10 -bottom-10 cursor-not-allowed'}`} src={switchPackage(leftGrandChildren?.right_child?.package)} alt={userData?.name} onClick={() => getUsersNode(leftGrandChildren?.right_child?.id || null)} />
                        <p className="text-white group-hover:opacity-100 transition-opacity absolute -bottom-14 left-1/2 transform -translate-x-1/2">{leftGrandChildren?.right_child?.name || ""} <span className="block lg:hidden text-blue-200 uppercase"> {t("_NETWORK._RIGHT")}</span></p>
                      </div>
                      <div className="flex justify-around  flex-col relative w-36 group cursor-pointer">
                        <img className={`w-32 h-32 mx-auto z-40 ${rightGrandChildren?.left_child ? '-bottom-11 opacity-70 hover:opacity-100 ' : 'opacity-10 -bottom-10 cursor-not-allowed'}`} src={switchPackage(rightGrandChildren?.left_child?.package)} alt={userData?.name} onClick={() => getUsersNode(rightGrandChildren?.left_child?.id || null)} />
                        <p className="text-white group-hover:opacity-100 transition-opacity absolute -bottom-14 left-1/2 transform -translate-x-1/2">{rightGrandChildren?.left_child?.name || ""} <span className="block lg:hidden text-blue-200 uppercase"> {t("_NETWORK._LEFT")}</span></p>
                      </div>
                      <div className="flex justify-around  flex-col relative w-36 group cursor-pointer">
                        <img className={`w-32 h-32 mx-auto z-40 ${rightGrandChildren?.right_child ? '-bottom-11 opacity-70 hover:opacity-100 ' : 'opacity-10 -bottom-10 cursor-not-allowed'}`} src={switchPackage(rightGrandChildren?.right_child?.package)} alt={userData?.name} onClick={() => getUsersNode(rightGrandChildren?.right_child?.id || null)} />
                        <p className="text-white group-hover:opacity-100 transition-opacity absolute -bottom-14 left-1/2 transform -translate-x-1/2">{rightGrandChildren?.right_child?.name || ""} <span className="block lg:hidden text-blue-200 uppercase"> {t("_NETWORK._RIGHT")}</span></p>
                      </div>
                    </div>
                  </div>
                </>
              }
            </div>


          </div>
        </div>
        {/** FIN  */}
        <div className="bg-black/60 text-white lg:p-8 p-4 rounded-lg w-full border-zinc-600 border-2 w-full  ">
          <h2 className="text-1xl my-2">{t("_NETWORK._DIRECTS")}</h2>

          <div className="mb-4">
            <input
              type="text"
              placeholder={t("_NETWORK._SEARCHFORUSERNAME")}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full lg:w-1/3 p-2 rounded border border-zinc-600 text-black"
            />
          </div>
          <div className="flex flex-col lg:flex-row gap-4 p-4 h-auto w-full">
            <div className="relative overflow-x-auto w-full">
              <table className="w-full text-sm text-left rtl:text-right text-gray-500 rounded-lg ">
                <thead className="text-md text-white border-b-2">
                  <tr className="bg-black/60 text-blue-800 lg:text-1xl uppercase">
                    <th className="px-6 py-4 ">
                      {t("_REGISTER._NAME")}
                    </th>
                    <th className="px-6 py-4">
                      {t("_REGISTER._WHATSAPP")}
                    </th>
                    <th className="px-6 py-4 ">
                      {t("_LOGIN._EMAIL")}
                    </th>
                    <th className="px-6 py-4 ">
                      {t("_PACKAGES._PACKAGE")}
                    </th>
                    <th className="px-6 py-4 ">
                      {t("_GLOBALV._TITLE")}
                    </th>
                    <th className="px-6 py-4 ">
                      {t("_DASHBOARD._STATUS")}
                    </th>
                    <th className="px-6 py-4 ">
                      {t("_NETWORK._NETWORK")}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredDirects.map((item, index) => (
                    <tr className={`border-b-2 ${parseInt(userData?.package_binary) >= item?.level ? "" : "bg-gray-500 opacity-40"}`} key={index}>
                      <th scope="row" className="px-6 py-4 font-medium whitespace-nowrap text-white hover:underline">
                        {item?.name}
                      </th>
                      <td className="px-6 py-4 text-white">
                        {item?.whatsapps ? item?.whatsapps : "N/A"}
                      </td>
                      <td className="px-6 py-4 text-white">
                        {item?.email}
                      </td>
                      <td className="px-6 py-4 text-white">
                        <img className={`w-10 h-10 mx-auto z-40 `}
                          src={switchPackage(item?.package)}
                          alt={item?.package} />
                      </td>
                      <td className="px-6 py-4 text-white">
                        {item?.range_volumen}
                      </td>
                      <td className="px-6 py-4 text-white">
                        <StatusNetwork active={item?.active || 0} />
                      </td>
                      <td className="px-6 py-4 text-white">
                        {getTranslatedDirection(item?.referred_direction)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div >
      </div >
    </>
  );
}
